import React from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getDesignations } from '../redux.actions';

const SelectDesignation = ({ getDesignations, input: { value, onChange } }) => {
    const [designations, setDesignations] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getDesignations({
            handleSubmit: (data) => {
                setIsLoading(false);
                if (data && data.data) {
                    setDesignations(
                        data.data.map((designation) => ({
                            name: designation.name,
                            value: designation.name
                        }))
                    );
                }
            }
        });
    }, [getDesignations]);

    const selectedDesignation =
        designations.find((d) => String(d.value) === String(value)) || null;

    return (
        <Autocomplete
            size='small'
            sx={{
                minWidth: 158,
                backgroundColor: theme => theme.palette.common.paper
            }}
            componentsProps={{
                paper: {
                    sx: {
                        '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                        }
                    }
                }
            }}
            options={designations}
            getOptionLabel={(option) => option.name || ''}
            value={selectedDesignation}
            onChange={(event, newValue) => {
                onChange(newValue ? newValue.value : '');
            }}
            loading={isLoading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label='Designation'
                    placeholder='Select designation'
                    sx={{
                        '& .MuiInputBase-input': { fontSize: '12px' },
                        '& .MuiInputLabel-root': { fontSize: '12px' }
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {isLoading ? (
                                    <CircularProgress
                                        color='inherit'
                                        size={20}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
        />
    );
};

const mapDispatchToProps = (dispatch) => ({
    getDesignations: (payload) => dispatch(getDesignations(payload))
});

export default connect(null, mapDispatchToProps)(SelectDesignation);
